import { IGeometryPointFlat } from 'sharedtypes/math';

import { Pointofview } from '~/Scene/Pointofview/pointofview';
import { ICameraGeometryPoint } from '~/Scene/System/systemCamera';
import { _pointofviewsManager } from '../studioScene';

export const FIRST_FRAME_NAME = 'Video SceneView';

export const addPointOfView = (geo?: ICameraGeometryPoint, name?: string): void => {
    const povList = _pointofviewsManager.getPointofviews();
    const nb = povList.length;
    const newPovName = name || `SceneView ${(nb + 1).toString()}`;

    const newPointofviewOptions: IGeometryPointFlat = {
        name: newPovName,
        position: geo.position,
        rotation: geo.rotation,
    };
    _pointofviewsManager.addPointofview(newPointofviewOptions);
};

export const deletePointOfView = (pov: Pointofview): void => {
    _pointofviewsManager._removePointofview(pov);
};

export const setVideoFirstFrame = (geo: ICameraGeometryPoint): void => {
    const povs = _pointofviewsManager.getPointofviews();
    const nPov: IGeometryPointFlat = {
        name: FIRST_FRAME_NAME,
        position: geo.position,
        rotation: geo.rotation,
    };
    const idx = povs.findIndex((x) => x.name === FIRST_FRAME_NAME);
    if (idx > -1) {
        povs[idx].name = nPov.name;
        povs[idx].setPosition(nPov.position);
        povs[idx].setRotation(nPov.rotation);
        return;
    }
    addPointOfView(geo, FIRST_FRAME_NAME);
};
